export default {
    pluginName: 'clinical',
    backendDataType: 'CLINICAL',
    rowIdKey: 'CLINICAL_ID',
    edit: 'data_edit',
    count: 'clinical_count',
    totalCount: 'total_clinical_count',
    fieldI18nKey: 'commonClinical',
    maxPerFolder: 'max_clinical_per_folder',
    maxOp: 'max_op_clinical',
    staticFields: [],
    dataId: 'CLINICAL_ID',
};
